import React, {useState} from 'react'
import { useAuth } from '../components/AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';

function Login({closeLoginModal}) {
    const { session, loginUser, signUpUser, initiateSSO } = useAuth();

    const location = useLocation();
    const navigate = useNavigate();

    const [first_name, setFirstName] = useState('');
    const [last_name, setLastName] = useState('');
    const [company_name, setCompanyName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const [error, setError] = useState('');
    const [isSignUp, setIsSignUp] = useState(false);
    const [showSSO, setShowSSO] = useState(false);
    const [ssoTenant, setSsoTenant] = useState('');
    const [ssoLoading, setSsoLoading] = useState(false);

    const handleSignUp = async (e) => {
        e.preventDefault();
        setError('');
        const name = first_name + ' ' + last_name;
        const result = await signUpUser(email, password, name, company_name);
        console.log('signUp result:', result)
        if (result?.success) {
            // Signup successful - close modal and show confirmation message
            sessionStorage.setItem('signup_success', 'true');
            closeLoginModal();
            // Force Landing to re-check sessionStorage by triggering a state update
            window.dispatchEvent(new Event('signupSuccess'));
        } else if (result?.error) {
            // Map invite-only error to user-friendly message
            if (result.error.includes('invite-only') || result.error.includes('not authorized')) {
                setError('Scuttlebutt Research is currently invite-only. Please contact us for access.');
            } else {
                setError(result.error);
            }
        }
    };

    const handleLogIn = async (e) => {
        e.preventDefault();
        setError('');
        const loginError = await loginUser(email, password);
        console.log('loginError:', loginError)
        if (loginError) {
            setError(loginError);
        }
        // If no error, session state will be updated and component will re-render
        // to show the "Logged in!" success view with "Get Started Now" button
    };

    // handle closing modal
    const handleModalClose = () => {
        console.log('location:', location)
        if (location.pathname === '/' || location.pathname.includes('case-study')) {
            // route the user to /search
            navigate('/search');
        }
        closeLoginModal();
    }

    const handleSSO = async (e) => {
        e.preventDefault();
        setError('');
        if (!ssoTenant) {
            setError('Please enter your company domain or work email.');
            return;
        }
        const tenant = (ssoTenant.includes('@') ? ssoTenant.split('@')[1] : ssoTenant).trim().toLowerCase();
        setSsoLoading(true);
        await initiateSSO(tenant);
        setSsoLoading(false);
    };

    if (!session) {
        return (
            <div className='form-container'>
                {showSSO ? (
                    <form onSubmit={handleSSO}>
                        <div className='form-input'>
                            <label htmlFor="sso_tenant">Work Email or Company Domain</label>
                            <input
                                type="text"
                                id="sso_tenant"
                                placeholder="you@acme.com or acme.com"
                                value={ssoTenant}
                                onChange={(e) => setSsoTenant(e.target.value)}
                                required
                            />
                        </div>
                        {error && <p className="error-message">{error}</p>}
                        <button type="submit" className="btn btn-primary btn-full" disabled={ssoLoading}>
                            {ssoLoading ? 'Redirecting to SSO...' : 'Continue with SSO'}
                        </button>
                        <button type="button" className="sign-in-link" onClick={() => setShowSSO(false)}>
                            Back to email login
                        </button>
                    </form>
                ) : isSignUp ? (
                    <form onSubmit={handleSignUp}>
                        <div className='form-input'>
                            <label htmlFor='first_name'>First Name</label>
                            <input
                                type="text"
                                id="first_name"
                                value={first_name}
                                onChange={(e) => setFirstName(e.target.value)}
                                required
                            />
                        </div>
                        <div className='form-input'>
                            <label htmlFor="last_name">Last Name</label>
                            <input
                                type="text"
                                id="last_name"
                                value={last_name}
                                onChange={(e) => setLastName(e.target.value)}
                                required
                            />
                        </div>
                        <div className='form-input'>
                            <label htmlFor="company_name">Company Name</label>
                            <input
                                type="text"
                                id="company_name"
                                value={company_name}
                                onChange={(e) => setCompanyName(e.target.value)}
                                required
                            />
                        </div>
                        <div className='form-input'>
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>
                        <div className='form-input'>
                            <label htmlFor="password">Password</label>
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>
                        {error && <p className="error-message">{error}</p>}
                        <button type="submit" className="btn btn-primary btn-full">Sign Up</button>
                        <button type="button" className="sign-in-link" onClick={() => setIsSignUp(false)}>
                            Already have an account? Sign in
                        </button>
                    </form>
                ) : (
                    <form onSubmit={handleLogIn}>
                        <div className='form-input'>
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>
                        <div className='form-input'>
                            <label htmlFor="password">Password</label>
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>
                        {error && <p className="error-message">{error}</p>}
                        <button type="submit" className="btn btn-primary btn-full">Sign In</button>
                        <div className="sign-in-link" style={{ textAlign: 'center', marginTop: '8px' }}>
                            <span style={{ color: '#999', fontSize: '13px' }}>or</span>
                        </div>
                        <button type="button" className="btn btn-full" onClick={() => setShowSSO(true)}
                            style={{ marginTop: '8px', background: 'transparent', border: '1px solid #ccc' }}>
                            Sign in with SSO
                        </button>
                        <button type="button" className="sign-in-link" onClick={() => setIsSignUp(true)}>
                            Don't have an account? Sign up
                        </button>
                    </form>
                )}
            </div>
        )
    } else {
        return (
            <div className='form-container'>
                <div className='logged-in-container'>
                    <h2>Logged in!</h2>
                    <p>Welcome to Scuttlebutt.</p>
                </div>
                <button className="btn btn-primary btn-full" onClick={handleModalClose}>
                    Get Started Now
                </button>
            </div>
        )
    }
}

export default Login